import { PlanningEntityIdentifier } from 'generated/index';

const PREFIX = 'APPOINTMENTS_OVERVIEW';

export const APPOINTMENTS_OVERVIEW_SESSION_STORAGE_KEYS = {
  FILTERED_PARTICIPANT: `${PREFIX}_FILTERED_PARTICIPANT`
};

// Entity types supported by the appointments overview participant filter.
export const PARTICIPANT_ENTITY_TYPES: PlanningEntityIdentifier['planningEntityType'][] =
  ['EMPLOYEE', 'CLIENT', 'RESOURCE'];

export type AppointmentsOverviewParticipant = {
  planningEntity: PlanningEntityIdentifier;
  label: string;
};
